import React from 'react';
import classes from './NavigationLinks.css';
import { NavLink } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

const navigationLinks = (props) => {
    let ulClass = ''
    if(props.isNav) {
        ulClass = classes.appNavList
    }
return (
<ul className={ulClass}>
    <li className={classes.appNavListItem} ><NavLink  activeClassName='appNavLinkActive' to={{ pathname:'/', hash:'#home'}}  isActive={activeOnHash('#home')}>Home</NavLink></li>
    <li className={classes.appNavListItem} ><NavLink activeClassName='appNavLinkActive' to={{ pathname:'/', hash:'#about-me'}}   isActive={activeOnHash('#about-me')} >About Me</NavLink></li>
    <li className={classes.appNavListItem} ><NavLink activeClassName='appNavLinkActive' to={{ pathname:'/', hash:'#experience'}}   isActive={activeOnHash('#experience')}>Experience</NavLink></li>
    <li className={classes.appNavListItem} ><NavLink activeClassName='appNavLinkActive' to={{ pathname:'/', hash:'#personalProjects'}}   isActive={activeOnHash('#personalProjects')}>Personal Projects</NavLink></li>
    <li className={classes.appNavListItem} ><NavLink activeClassName='appNavLinkActive' to={{ pathname:'/', hash:'#commercialProjects'}}   isActive={activeOnHash('#commercialProjects')}>Commercial Projects</NavLink></li>
    <li className={classes.appNavListItem} ><NavLink activeClassName='appNavLinkActive' to="/contact-me" >Contact Me</NavLink></li>
</ul>);
};

const activeOnHash = (hashName) => {
return (match, location) => {
return location.hash == hashName;    
};
}
export default navigationLinks;


// WEBPACK FOOTER //
// ./src/components/UI/NavigationLinks/NavigationLinks.js